import { PRINT_VIEW_STORAGE_KEY, PrintViewLayoutState } from "./model";

/**
 * Survives React StrictMode remounts within the same JS context.
 * New tabs start with a clean module scope.
 */
let memoryCache: PrintViewLayoutState | null = null;

export const savePrintViewState = (state: PrintViewLayoutState) => {
  const serialized = JSON.stringify(state);
  memoryCache = state;

  // sessionStorage may not clone into a window.open(_blank) tab (noopener).
  // localStorage is shared across tabs for the same origin.
  try {
    sessionStorage.setItem(PRINT_VIEW_STORAGE_KEY, serialized);
  } catch {
    // ignore quota / private mode failures
  }
  try {
    localStorage.setItem(PRINT_VIEW_STORAGE_KEY, serialized);
  } catch {
    // ignore quota / private mode failures
  }
};

export const consumePrintViewState = (): PrintViewLayoutState | null => {
  if (memoryCache) {
    return memoryCache;
  }

  let stored: string | null = null;
  try {
    stored =
      sessionStorage.getItem(PRINT_VIEW_STORAGE_KEY) ||
      localStorage.getItem(PRINT_VIEW_STORAGE_KEY);
  } catch {
    stored = null;
  }

  if (!stored) {
    return null;
  }

  try {
    const parsed = JSON.parse(stored) as PrintViewLayoutState;
    memoryCache = parsed;

    try {
      sessionStorage.removeItem(PRINT_VIEW_STORAGE_KEY);
    } catch {
      // ignore
    }
    try {
      localStorage.removeItem(PRINT_VIEW_STORAGE_KEY);
    } catch {
      // ignore
    }

    return parsed;
  } catch {
    return null;
  }
};

/** Test-only helper to reset in-memory cache between tests */
export const resetPrintViewMemoryCache = () => {
  memoryCache = null;
};
